/**
 * @module lib/log
 * Set up and expose logging functions.
 * Use this instead of calling `console` methods directly.
 * Uses [loglevel]{@link https://github.com/pimterry/loglevel}.
 */

import * as logger from "loglevel";

// If we're in production, only log errors
if (process.env.NODE_ENV === 'production') {
  logger.setLevel(logger.levels.ERROR)
} else {
  logger.setLevel(logger.levels.DEBUG)
}

// export main logging object for use by app
export default logger;



// WEBPACK FOOTER //
// ./src/lib/log/index.js